import React, { FC, FormEvent, useState } from "react";

import { Form } from "react-bulma-components";

import styled from "@emotion/styled";

import ArrowRightIcon from "../../../shared/icons/ArrowRightIcon";
import { navigate } from "../../../shared/LinkComponent";
import { SearchInputWithGoogleMapsScript } from "../../../shared/maps/SearchInput";
import { RouteFinder } from "../../../shared/RouteLink/Route";
import { europeIsh } from "../hardCodedMapSearchBounds";
import { mkLink } from "./link";

const StyledButton = styled.button`
    display: flex;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 20px;
    font-size: 1rem;
    font-weight: 900;
    color: white;
    cursor: pointer;
    background-color: unset;
    border: unset;

    &:hover {
        color: white;

        & > div {
            left: 20px;
        }
    }
`;

const IconContainer = styled.div`
    position: relative;
    left: 10px;
    display: flex;
    width: 25px;
    transition: all 250ms ease-out;
`;

export type SearchFieldLinkProps = Omit<RouteFinder, "location" | "map"> & {
    map?: Omit<RouteFinder["map"], "center">;
};

const SearchFieldLink: FC<SearchFieldLinkProps> = ({
    children,
    properties,
    hoyerStationTypes,
    acceptancePartnerStationTypes,
    fuelTypes,
    map: { zoom } = {},
    ...props
}) => {
    const [{ location, map: { center } = { center: undefined } }, setState] =
        useState<
            Pick<RouteFinder, "location"> & {
                map?: Pick<RouteFinder["map"], "center">;
            }
        >({});

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                navigate(
                    mkLink({
                        location,
                        properties,
                        hoyerStationTypes,
                        acceptancePartnerStationTypes,
                        fuelTypes,
                        map: {
                            center,
                            zoom,
                        },
                    })
                );
            }}
            {...props}
        >
            <Form.Field
                renderAs={SearchInputWithGoogleMapsScript}
                aria-label="Postleitzahl oder Ort"
                placeholder="Postleitzahl oder Ort"
                aria-placeholder="21337"
                value={location ?? ""}
                onChange={(event: FormEvent<HTMLInputElement>) =>
                    setState({
                        location: (event.target as HTMLInputElement).value,
                    })
                }
                onPlacesChange={(
                    [
                        {
                            formatted_address,
                            geometry: { location = undefined } = {},
                        },
                    ]: google.maps.places.PlaceResult[] | undefined = [{}]
                ) =>
                    setState({
                        location: formatted_address,
                        map: {
                            center: location && {
                                lat: location.lat(),
                                lng: location.lng(),
                            },
                        },
                    })
                }
                name="location"
                withoutWrapper
                required
                bounds={europeIsh}
            />

            <StyledButton type="submit">
                {children}
                <IconContainer>
                    <ArrowRightIcon color="white" />
                </IconContainer>
            </StyledButton>
        </form>
    );
};
export default SearchFieldLink;
